import { requestYieldCallback } from '@theme/utilities';

const dataElement = document.getElementById('klaviyo-theme-event-data');
const trackedVariantByPicker = new WeakMap();

const getPageEventData = () => {
  try {
    return JSON.parse(dataElement?.textContent || '{}');
  } catch {
    return {};
  }
};

const track = (name, properties) => {
  if (!properties || !window.klaviyo?.push) return;
  window.klaviyo.push(['track', name, properties]);
};

const trackPageEvents = () => {
  const data = getPageEventData();

  requestYieldCallback(() => {
    track('Viewed Collection', data.collection);
    track('Submitted Search', data.search);
  });
};

if (document.readyState === 'complete') {
  trackPageEvents();
} else {
  window.addEventListener('load', trackPageEvents, { once: true });
}

document.addEventListener('variant:update', (event) => {
  const variant = event.detail?.resource;
  const productId = event.detail?.data?.productId;
  const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;

  // This custom Klaviyo event is a PDP size selection, not a quick-add/card
  // variant event. Limiting it also prevents duplicate app-rendered forms from
  // emitting the same event.
  if (!variant || !productId || !picker || picker.dataset.templateProductMatch !== 'true') return;

  const size = variant.option1;
  const relativeProductUrl = picker.dataset.productUrl;
  if (!size || !relativeProductUrl || !variant.id) return;

  const variantKey = String(variant.id);
  if (trackedVariantByPicker.get(picker) === variantKey) return;
  trackedVariantByPicker.set(picker, variantKey);

  requestYieldCallback(() => {
    if (!picker.isConnected || trackedVariantByPicker.get(picker) !== variantKey) return;

    const productUrl = new URL(relativeProductUrl, window.location.origin);
    productUrl.searchParams.set('variant', variantKey);
    const price = Number(variant.price || 0) / 100;

    track('Size Selected', {
      Name: variant.name?.split(' - ')[0],
      Price: price,
      Value: price,
      ProductID: productId,
      VariantID: variant.id,
      URL: productUrl.toString(),
      Size: size,
      Available: variant.available,
      OnSale: variant.compare_at_price > variant.price,
    });
  });
});
